<template>
  <div>
    <div v-if="isLine1Split">
      <div
        v-for="(field,index) in separateLineOneFields"
        :key="field"
        class="row">
        <div class="col">
          <div class="form-group">
            <label>{{ labels[field] }}</label>
            <input
              v-validate="{ required: true }"
              v-model="addressLine1Value[index]"
              :name="`${name}-${field}`"
              :data-test="field"
              :class="{ 'is-invalid': errors.has(`${name}-${field}`) }"
              :data-vv-as="labels[field]"
              :disabled = "isDisabled"
              class="form-control"
              type="text"
              @input="input"
              @blur="blur"
            >
            <div
              v-if="errors.has(`${name}-${field}`)"
              class="invalid-feedback">
              {{ errors.first(`${name}-${field}`) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>{{ labels.line1 }}</label>
            <input
              v-validate="{ required: true }"
              v-model="address.line1"
              :name="`${name}-line1`"
              :class="{ 'is-invalid': errors.has(`${name}-line1`) }"
              :data-vv-as="labels.line1"
              :disabled = "isDisabled"
              class="form-control"
              type="text"
              data-test="line1"
              @input="input"
              @blur="blur"
            >
            <div
              v-if="errors.has(`${name}-line1`)"
              class="invalid-feedback">
              {{ errors.first(`${name}-line1`) }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label>{{ labels.line2 }}</label>
          <input
            v-model="address.line2"
            :name="`${name}-line2`"
            :class="{ 'is-invalid': errors.has(`${name}-line2`) }"
            :data-vv-as="labels.line2"
            :disabled = "isDisabled"
            class="form-control"
            type="text"
            data-test="line2"
            @input="input"
            @blur="blur"
          >
          <div
            v-if="errors.has(`${name}-line2`)"
            class="invalid-feedback">
            {{ errors.first(`${name}-line2`) }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="isLine3Split">
      <div
        v-for="(field, index) in separateLineThreeFields"
        :key="field"
        class="row">
        <div class="col">
          <div class="form-group">
            <label>{{ labels[field] }}</label>
            <input
              v-model="addressLine3Value[index]"
              :name="`${name}-${field}`"
              :data-test="field"
              :class="{ 'is-invalid': errors.has(`${name}-${field}`) }"
              :data-vv-as="labels[field]"
              :disabled = "isDisabled"
              class="form-control"
              type="text"
              @input="input"
              @blur="blur"
            >
            <div
              v-if="errors.has(`${name}-${field}`)"
              class="invalid-feedback">
              {{ errors.first(`${name}-${field}`) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div
        v-if="isLine3Enabled"
        class="row">
        <div class="col">
          <div class="form-group">
            <label>{{ labels.line3 }}</label>
            <input
              v-model="address.line3"
              :name="`${name}-line3`"
              :class="{ 'is-invalid': errors.has(`${name}-line3}`) }"
              :data-vv-as="labels.line3"
              :disabled = "isDisabled"
              class="form-control"
              type="text"
              data-test="line3"
              @input="input"
              @blur="blur"
            >
            <div
              v-if="errors.has(`${name}-line3`)"
              class="invalid-feedback">
              {{ errors.first(`${name}-line3`) }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    address: {
      type: Object,
      default: Object
    },
    labels: {
      type: Object,
      default: Object
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    },
    addressConfig: {
      type: Object,
      required: true
    },
    separateLineOneFields: {
      type: Array,
      required: true
    },
    separateLineThreeFields: {
      type: Array,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addressLine1Value: {},
      addressLine3Value: {}
    }
  },
  computed: {
    isLine1Split () {
      return this.separateLineOneFields.length > 0
    },
    isLine3Split () {
      return this.separateLineThreeFields.length > 0
    },
    isLine3Enabled () {
      return this.isEnabled('line3')
    }
  },
  methods: {
    input () {
      if (this.isLine1Split) {
        this.combineLine1()
      }
      if (this.isLine3Split) {
        this.combineLine3()
      }
      this.$emit('input')
    },
    blur () {
      this.$emit('blur')
    },
    isEnabled (field) {
      return this.addressConfig[field] && this.addressConfig[field].enabled
    },
    combineLine1 () {
      this.address.line1 = Object.values(this.addressLine1Value).filter(Boolean).join(' ')
    },
    combineLine3 () {
      this.address.line3 = Object.values(this.addressLine3Value).filter(Boolean).join(' ')
    }
  }
}
</script>
